import { render, staticRenderFns } from "./InvitePage.vue?vue&type=template&id=1a598a00"
import script from "./InvitePage.vue?vue&type=script&lang=js"
export * from "./InvitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports